import { memo } from 'react';
import type { LayoutFamilyLine } from './useFamilyTreeLayout';
import { NODE_H, FAMILY_COLORS } from './useFamilyTreeLayout';

// ─── Stil ────────────────────────────────────────────────────────────────────

const STROKE_W       = 2;
const STROKE_OP      = 0.85;
const DEFAULT_STROKE = '#94a3b8';

// ─── LinkLayer ───────────────────────────────────────────────────────────────

interface LinkLayerProps {
  lines: LayoutFamilyLine[];
  colored?: boolean;
}

export const LinkLayer = memo(function LinkLayer({ lines, colored = true }: LinkLayerProps) {
  return (
    <g className="link-layer">
      {lines.map((line, i) => {
        const { symbolX, parentY, junctionY, childPositions, isCouple, colorIndex } = line;

        // Start-Y: unterhalb des Paar-Symbols oder der Karte
        const lineStartY = isCouple ? parentY + 12 : parentY + NODE_H / 2;

        if (childPositions.length === 0) return null;

        // Farbe: bunt oder einheitlich grau
        const color = colored
          ? FAMILY_COLORS[colorIndex % FAMILY_COLORS.length]
          : DEFAULT_STROKE;

        const allXs = [symbolX, ...childPositions.map(c => c.x)];
        const minX = Math.min(...allXs);
        const maxX = Math.max(...allXs);

        const pathSegments = [
          // Senkrecht runter von den Eltern zur Querleiste
          `M ${symbolX} ${lineStartY} L ${symbolX} ${junctionY}`,
          // Waagerechte Querleiste
          `M ${minX} ${junctionY} L ${maxX} ${junctionY}`,
          // Senkrecht runter zu jedem Kind
          ...childPositions.map(cp =>
            `M ${cp.x} ${junctionY} L ${cp.x} ${cp.y - NODE_H / 2}`
          ),
        ];

        return (
          <path
            key={i}
            d={pathSegments.join(' ')}
            fill="none"
            stroke={color}
            strokeWidth={STROKE_W}
            strokeLinecap="square"
            opacity={STROKE_OP}
          />
        );
      })}
    </g>
  );
});
